import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY, WHITE} from 'ui-library/Colors';

interface NoteLinkedEmbeddingPreviewProps {
  children: React.ReactNode;
  onClose: () => void;
}
export default function NoteLinkedEmbeddingPreview({
  children,
  onClose,
}: NoteLinkedEmbeddingPreviewProps): JSX.Element {
  return (
    <>
      <div className={css(styles.headerContainer)}>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          size={ButtonSize.SMALL}
          icon="cross-thick"
          text="Close preview"
          onClick={onClose}
        />
      </div>
      {children}
    </>
  );
}

const styles = StyleSheet.create({
  headerContainer: {
    padding: '5px 12px',
    borderBottom: `1px solid ${GRAY}`,
    background: WHITE,
  },
});
